export default __webpack_public_path__ + "static/media/home-shop-modern-08.cf5ea1f8.png";